<template>
  <div>
    <SellHeader :img_header="header_image" header="แก้ไขคำสั่งซื้อ" link_back="sell/ordercustomermain"/>
    <Order_customer_edit/>
  </div>
</template>

<script>
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/agreement.png";
import Order_customer_edit from "@/components/admin/sell/Order_customer_edit";
export default {
  name: "OrderCustomerEdit",
  components: {
    Order_customer_edit,
    SellHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
